import type { useSingleton } from "@tippyjs/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MiniMapIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { MiniMapWindow } from "@/interface/BottomBar/BottomRightBar/MiniMap/MiniMapWindow";
import { Tooltip } from "@/interface/ui/Tooltip";

type Props = {
    singletonTarget: ReturnType<typeof useSingleton>[1];
};

export const MiniMapButton = ({ singletonTarget }: Props) => {
    const { t } = useTranslation();
    const [showMap, setShowMap] = useState(false);
    const handleClick = () => setShowMap((prevState) => !prevState);

    return (
        <>
            <Tooltip singleton={singletonTarget} content={t("bottomBar.minimap")}>
                <BottomBarItem onClick={handleClick} active={showMap}>
                    <MiniMapIcon />
                </BottomBarItem>
            </Tooltip>
            {showMap && <MiniMapWindow />}
        </>
    );
};
